import Select from "react-select";
import FilterToggle from "../../atoms/FilterToggle";
import { optionsTypesInmuebles } from "../../../utils/optionsTypesInmuebles";

const rentaOptions = [
    { label: "Rentado", value: "true" },
    { label: "No rentado", value: "false" },
];

const hipotecaOptions = [
    { label: "Hipotecado", value: "true" },
    { label: "No hipotecado", value: "false" },
];

const InmueblesFilter = ({ filters, setFilters }) => {
    const handleChange = (e) => {
        setFilters({
        ...filters,
        [e.target.name]: e.target.value,
        });
    };

    const handleSelectChange = (name, selected) => {
        setFilters({
        ...filters,
        [name]: selected ? selected.value : "",
        });
    };

    const handleReset = () => {
        setFilters({
        name: "",
        address: "",
        type: "",
        isRented: "",
        isMortgaged: "",
        });
    };

    return (
        <FilterToggle>
            <div className="w-full grid grid-cols-2 md:grid-cols-5 gap-4">
                <input
                type="text"
                placeholder="Nombre"
                name="name"
                value={filters.name}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                />
                <input
                type="text"
                placeholder="Dirección"
                name="address"
                value={filters.address}
                onChange={handleChange}
                className="border p-2 rounded w-full"
                />

                {/* Tipo (Clasificación) */}
                <Select
                name="type"
                options={optionsTypesInmuebles}
                value={
                    optionsTypesInmuebles.find((opt) => opt.value === filters.type) || null
                }
                onChange={(selected) => handleSelectChange("type", selected)}
                placeholder="Tipo"
                className="text-sm"
                classNamePrefix="select"
                isClearable
                />

                {/* Rentado */}
                <Select
                name="isRented"
                options={rentaOptions}
                value={rentaOptions.find((opt) => opt.value === filters.isRented) || null}
                onChange={(selected) => handleSelectChange("isRented", selected)}
                placeholder="Renta"
                className="text-sm"
                classNamePrefix="select"
                isClearable
                />

                {/* Hipotecado */}
                <Select
                name="isMortgaged"
                options={hipotecaOptions}
                value={
                    hipotecaOptions.find((opt) => opt.value === filters.isMortgaged) || null
                }
                onChange={(selected) => handleSelectChange("isMortgaged", selected)}
                placeholder="Hipoteca"
                className="text-sm"
                classNamePrefix="select"
                isClearable
                />
            </div>

            <div className="flex justify-end">
                <button
                onClick={handleReset}
                className="text-gray-500 text-xs p-1"
                >
                Limpiar filtros
                </button>
            </div>
        </FilterToggle>
    );
};

export default InmueblesFilter;
